import { http, HttpResponse } from 'msw'
import { UserType, UserTypeResponse } from './auth-api'

// Default to BUYER user type for e2e tests
const defaultUserType: UserTypeResponse = {
  type: UserType.BUYER,
}

export const handlers = [
  http.get('/auth/user-type', () => {
    return HttpResponse.json(defaultUserType)
  }),
]
